import { persistor } from "redux/store";

const exceptions_default = [
  'lang',
  'languageCode',
  'timeZone',
];

// Keys that should always be removed regardless of exceptions
const alwaysRemoveKeys = ['persist:root'];

export const clearLocalStorage = async (exceptions: string[] = exceptions_default): Promise<void> => {
  if (!window.localStorage) {
    return;
  }
    // Pause persistor to prevent it from saving during logout
    await persistor.pause();

    // Purge Redux persist state
    await persistor.purge();
  // Get all keys from localStorage
  const allKeys = Object.keys(localStorage);

  const staticExceptions = ["releaseTourFinished"];
  
  // Filter keys to remove (all keys except exceptions, but always remove persist:root)
  const keysToRemove = allKeys.filter(
    key => ![...staticExceptions, ...exceptions].includes(key) || alwaysRemoveKeys.includes(key)
  );
  
  // Remove all keys except the exceptions
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
};

export default clearLocalStorage;

